/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
import { Route } from './Route.js';
export class WebappRoutes {
    lang;
    constructor(lang) {
        this.lang = lang;
    }
    landing() {
        return new Route('/:lang', this.lang);
    }
    map() {
        return new Route('/:lang/map', this.lang);
    }
    sharedMap() {
        return new Route('/:lang/shared-map/:projectId', this.lang);
    }
    confirmAccount() {
        // See ConfirmAccountTokenParam
        return new Route('/:lang/confirm-account', this.lang);
    }
    resetPassword() {
        // See ResetPasswordTokenParam
        return new Route('/:lang/reset-password', this.lang);
    }
    userAccount() {
        return new Route('/:lang/user-profile', this.lang);
    }
    legalMentions() {
        return new Route('/:lang/legal-mentions', this.lang);
    }
    funding() {
        return new Route('/:lang/funding', this.lang);
    }
    changelog() {
        return new Route('/:lang/changelog', this.lang);
    }
    moduleIndex() {
        return new Route('/:lang/modules', this.lang);
    }
    module() {
        return new Route('/:lang/modules/:moduleId', this.lang);
    }
    staticDocumentation() {
        return new Route('/documentation', this.lang);
    }
    getMainRoutes() {
        return [
            this.landing(),
            this.map(),
            this.sharedMap(),
            this.confirmAccount(),
            this.resetPassword(),
            this.userAccount(),
            this.legalMentions(),
            this.funding(),
            this.changelog(),
            this.moduleIndex(),
        ];
    }
}
// Search parameters used for account confirmation
export const ConfirmAccountTokenParam = 'token';
// Search parameters used for password reset
export const ResetPasswordTokenParam = 'token';
//# sourceMappingURL=WebappRoutes.js.map